import {
  IShipperRate,
  IShipperRatePayload,
  IShipperRateResponse,
} from 'apps/marketplace/store/shipperLane/types'

export const toShipperRatePayload = (shipperRate: IShipperRate): IShipperRatePayload => ({
  shipperLaneId: shipperRate.shipperLaneId,
  shipperApplicationId: shipperRate.shipperApplication?.id,
  equipmentKey: shipperRate.equipment?.key,
  pickupCity: shipperRate.pickup?.city,
  pickupPostalCode: shipperRate.pickup?.postalCode,
  pickupStateCode: shipperRate.pickup?.stateCode,
  pickupIsoCountryCode: shipperRate.pickup?.isoCountryCode,
  deliveryCity: shipperRate.delivery?.city,
  deliveryPostalCode: shipperRate.delivery?.postalCode,
  deliveryStateCode: shipperRate.delivery?.stateCode,
  deliveryIsoCountryCode: shipperRate.delivery?.isoCountryCode,
  isPickupDropTrailer: shipperRate.isPickupDropTrailer,
  isDeliveryDropTrailer: shipperRate.isDeliveryDropTrailer,
  awardType: shipperRate.awardType,
  volumeType: shipperRate.volumeType,
  volume: shipperRate.volume,
  startDate: shipperRate.startDate,
  endDate: shipperRate.endDate,
  rateAttributes: {
    amount: shipperRate.rate?.amount,
    rateTypeKey: shipperRate.rate?.rateTypeKey,
  },
  minChargeRateAttributes: shipperRate.minChargeRate
    ? {
        amount: shipperRate.minChargeRate.amount,
        rateTypeKey: shipperRate.minChargeRate.rateTypeKey,
      }
    : undefined,
})

export const fromShipperRateResponse = (response: IShipperRateResponse): IShipperRate => ({
  id: response.id,
  shipperLaneId: response.shipperLaneId,
  shipperApplication: {
    id: response.shipperApplicationId,
  },
  equipment: response.equipment,
  rfpName: response.rfpName,
  rate: response.rate,
  startDate: response.startDate,
  endDate: response.endDate,
  pickup: {
    city: response.pickupCity,
    postalCode: response.pickupPostalCode,
    stateCode: response.pickupStateCode,
    isoCountryCode: response.pickupIsoCountryCode,
  },
  delivery: {
    city: response.deliveryCity,
    postalCode: response.deliveryPostalCode,
    stateCode: response.deliveryStateCode,
    isoCountryCode: response.deliveryIsoCountryCode,
  },
  awardType: response.awardType,
  shipperMiles: response.shipperMiles,
  mapboxMiles: response.mapboxMiles,
  datMiles: response.datMiles,
  minChargeRate: response.minChargeRate,
  fuelRate: response.fuelRate,
  volume: response.volume,
  volumeType: response.volumeType,
  isPickupDropTrailer: response.isPickupDropTrailer,
  isDeliveryDropTrailer: response.isDeliveryDropTrailer,
})
